"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var reactstrap_1 = require("reactstrap");
var Styledanchor = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n"], ["\n"])));
var StyleDropdownToggle = styled_components_1.default(reactstrap_1.DropdownToggle)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\nwhite-space: nowrap;\noverflow: hidden;\ntext-overflow: ellipsis;\nbackground: transparent !important;\nborder:none !important;\nbox-shadow : none !important;\npadding-top:12px !important;\npadding-right:8px !important;\n"], ["\nwhite-space: nowrap;\noverflow: hidden;\ntext-overflow: ellipsis;\nbackground: transparent !important;\nborder:none !important;\nbox-shadow : none !important;\npadding-top:12px !important;\npadding-right:8px !important;\n"])));
var StyleDropdownMenu = styled_components_1.default(reactstrap_1.DropdownMenu)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\nbackground: transparent !important;\n\n"], ["\nbackground: transparent !important;\n\n"])));
var StyleDropdownItem = styled_components_1.default(reactstrap_1.DropdownItem)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n"], ["\n"])));
var languages = [
    {
        "ID": 1,
        "CODE": "en",
        "NAME": "English"
    },
    {
        "ID": 2,
        "CODE": "hi",
        "NAME": "हिंदी"
    },
    {
        "ID": 3,
        "CODE": "gu",
        "NAME": "ગુજરાતી"
    }
];
var LanguageLink = function (props) {
    var _a = react_1.useState(false), dropdownOpen = _a[0], setDropdownOpen = _a[1];
    // const [currentLanguage, setCurrentLanguage] = useState(locale);
    var toggleDropdown = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setDropdownOpen(!dropdownOpen);
            return [2 /*return*/];
        });
    }); };
    var switchLanguage = function (code) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            //  setCurrentLanguage(code);
            props.setLanguage(code);
            props.setMessages(code);
            setDropdownOpen(false);
            return [2 /*return*/];
        });
    }); };
    return (React.createElement("div", null,
        React.createElement(reactstrap_1.Dropdown, { isOpen: dropdownOpen, toggle: toggleDropdown },
            React.createElement(StyleDropdownToggle, { onClick: toggleDropdown },
                " ",
                React.createElement("i", { className: "fa fa-language", style: { paddingRight: '4px' } }),
                props.locale.toUpperCase(),
                React.createElement("i", { className: "fa fa-chevron-down", style: { paddingLeft: '5px', fontSize: '0.5em' } })),
            dropdownOpen ? (React.createElement(StyleDropdownMenu, { style: { left: '10px' } }, languages.map(function (lang) { return (React.createElement(StyleDropdownItem, { onClick: function () { return switchLanguage(lang.CODE); } },
                " ",
                lang.NAME,
                " ",
                lang.CODE == props.locale ? React.createElement("span", { style: { fontSize: '15px' } }, "\u2713") : null,
                " ")); }))) : null)));
};
exports.default = LanguageLink;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=LanguageLink.js.map